import { render } from "./Diaries.vue?vue&type=template&id=66fb7e7a&scoped=true"
import script from "./Diaries.vue?vue&type=script&lang=ts"
export * from "./Diaries.vue?vue&type=script&lang=ts"

import "./Diaries.vue?vue&type=style&index=0&id=66fb7e7a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-66fb7e7a"

export default script